import { render } from "./DatasetShare.vue?vue&type=template&id=404869aa"
import script from "./DatasetShare.vue?vue&type=script&lang=js"
export * from "./DatasetShare.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__